import $ from 'jquery';
import Menu from './Menu';
import Drupal from './Drupal';
import Sticky from './Sticky';
import Search from './Search';
import Toolbar from './Toolbar';
import Gallery from './Gallery';
import DDTemplates from './DDTemplates';
import SmartFooter from './SmartFooter';
import CalendarList from './CalendarList';
import CalendarFilters from './CalendarFilters';
import FixNavigation from './FixNavigation';
import TermNavigation from './TermNavigation';
import Pods from './Pods';
import Hero from './Hero';
import Banner from './Banner';
import HomepageVideo from './HomepageVideo';
import HeroVideo from './HeroVideo';
import EventSlider from './EventSlider';
import Excursion from './Excursion';
import Viewable from './Viewable';
import Modaal from './Modaal';

const ESC_KEY = 27;

// Add the theme behaviors
Drupal.behavior((context) => {
  // Helper class to signal the loading of behaviors.
  $(document.body).addClass('initialized');

  // Theme helper to hide/show the logo in the header on desktop.
  const hasBanner = $('.page-top .block:not(.placeholder-block)', context).length;
  if (!hasBanner) {
    $(document.body).addClass('no-banner');
  }

  // DD Template Behaviors
  // eslint-disable-next-line no-new
  new DDTemplates(context);

  // Replace Lightbox lightframe functionality with Modaal.
  document.querySelectorAll('.open-lightframe').forEach((element) => {
    if (!element.Modaal) {
      const selector = '.node-header a, .field-image a, .link-read-more a';
      element.Modaal = new Modaal(element, selector);
    }
  });

  // Replace Lightbox slideshow functionality with Modaal.
  document.querySelectorAll('.te-open-slideshow .node, .te-open-slideshow.node').forEach((element) => {
    if (!element.Modaal) {
      const selector = '.field-image a';
      element.Modaal = new Modaal(element, selector);
    }
  });

  // Replace Lightbox and Lighframe straggelers.
  $('[rel^=lightbox], [rel^=lightframe]', context).closest('.node').each((i, element) => {
    if (!element.Modaal) {
      const selector = '.node-header a, .field-image a, .link-read-more a';
      element.Modaal = new Modaal(element, selector);
    }
  });

  // Hero Banner
  $('.hero.banner', context).each((i, element) => {
    if (!element.Hero) {
      element.Hero = new Hero(element);
    }
  });

  // Hero Banner with Video
  $('.hero.banner .has-video', context).each((i, element) => {
    if (!element.HeroVideo) {
      element.HeroVideo = new HeroVideo(element);
    }
  });

  // Term Banner
  $('.term.banner', context).each((i, element) => {
    if (!element.Banner) {
      element.Banner = new Banner(element);
    }
  });

  // Homepage Video band
  $('.video.block', context).each((i, element) => {
    if (!element.HomepageVideo) {
      element.HomepageVideo = new HomepageVideo(element);
    }
  });

  // Fix our damn menus from displaying orphaned children
  $('.primary-navigation, .term-nav', context).each((i, element) => {
    if (!element.FixNavigation) {
      element.FixNavigation = new FixNavigation(element);
    }
  });

  // Main/Primary Site Navigation
  $('#block-nice_menus-3', context).each((i, element) => {
    if (!element.Menu) {
      element.Menu = new Menu(element);
    }
  });

  // Term Navigation functionality
  $('.term-nav', context).each((i, element) => {
    if (!element.TermNavigation) {
      element.TermNavigation = new TermNavigation(element);
    }
  });

  // Sticky sidebars
  $('.page-sidebar', context).each((i, element) => {
    if (!element.Sticky) {
      element.Sticky = new Sticky(element);
    }
  });

  // Pods
  $('.pods.block .views-row', context).each((i, element) => {
    if (!element.Pods) {
      element.Pods = new Pods(element);
    }
  });

  // Controls the states of the menu and search states
  $('.toolbar', context).each((i, element) => {
    if (!element.Toolbar) {
      element.Toolbar = new Toolbar(element);
    }
  });

  // Search headerlink
  $('nav.headerlinks', context).each((i, element) => {
    if (!element.Search) {
      element.Search = new Search(element, context);
    }
  });

  // Smart Footer
  $('.page-footer', context).each((i, element) => {
    const $footprint = $('.footprint', context);
    if (!element.SmartFooter && $footprint.length) {
      element.SmartFooter = new SmartFooter(element, $footprint);
    }
  });

  // Homepage Event Slider
  $('.events.block', context).each((i, element) => {
    if (!element.EventSlider) {
      element.EventSlider = new EventSlider(element);
    }
  });

  // Homepage Excursion Section
  $('.excursion.block', context).each((i, element) => {
    if (!element.Excursion) {
      element.Excursion = new Excursion(element);
    }
  });

  const viewableSelectors = [
    '.experience.block .views-row',
    '.events.block .views-row',
    '.video.block .node-header',
    '.excursion.block .title, .excursion.block .subtitle, .excursion.block .more',
    '.news.block .field-image',
    '.instagram .feed',
  ];

  // Homepage Viewable Transitions
  $(viewableSelectors.join(','), context).each((i, element) => {
    if (!element.Viewable) {
      element.Viewable = new Viewable(element);
    }
  });

  // Photo Galleries
  $('.node-content .photo-gallery, .photo-gallery .node-image, .photo-gallery .node-upper-image', context).each((i, element) => {
    if (!element.Gallery) {
      element.Gallery = new Gallery(element);
    }
  });

  // Calendar of Events View
  $('.calendar-feed', context).each((i, element) => {
    if (!element.CalendarList) {
      element.CalendarList = new CalendarList(element);
    }
  });

  // Calendar Filters for both views
  $('.calendar-feed, .view-grid-calendar', context).each((i, element) => {
    if (!element.CalendarFilters) {
      element.CalendarFilters = new CalendarFilters(element);
    }
  });

  // Cleanup empty calendar filters
  const hasFilters = $('.view-grid-calendar ul.filters li.filter', context).length;
  if (!hasFilters) {
    $('.view-grid-calendar ul.filters', context).remove();
  }

  // Add Sitemap output using the digitaldcore.js function
  const $map = $('#sitemap', context);
  const $nav = $('#sitemap .content', context);

  if ($map.length && $nav.length) {
    Drupal.digitaldcoreCreateSiteMap($map, $nav);
    $map.addClass('ready');
  }

  // Close flyout when Escape key is pressed.
  $(window).keydown((event) => {
    if (event.which === ESC_KEY) {
      $(document.body).removeClass('menu-active search-active');
    }
  });

  // Unlink headings
  $('.experience-header.block', context).each((i, element) => {
    if (!element.headingsUnlinked) {
      element.headingsUnlinked = true;
      $(element).find('.node-header a').children().unwrap();
    }
  });

  // Create a unique of content for Business and Attractoin post type Hours of Operation.
  $('body.pt179 .node-content, body.pt185 .node-content', context).each((i, element) => {
    const $hours = $(element).find('table');
    const $block = $('<div class="hours block"></div>');
    if ($hours.length) {
      $block.append('<h2 class="block-title">Hours of Operation</h2>', $hours);
      $block.insertAfter('#block-digitaldcore-node_fields');
    }
  });

  // Create unique profile block title names for these full post displays.
  // Attraction types
  $('body.pt179 .profile-posts .block-title', context).each((i, element) => {
    $(element).html('Type of Attraction');
  });
  // Business types
  $('body.pt185 .profile-posts .block-title', context).each((i, element) => {
    $(element).html('Type of Business');
  });

  // Remove links from tabIndex
  $('.banner.block .field-image a', context).attr('tabIndex', '-1');
  $('.experience.block .field-image a', context).attr('tabIndex', '-1');
});
